import { createContext, useContext, useEffect, useState } from "react";
import "./login.css"
import axios from "axios";
import { Link, Route, Routes, useNavigate } from "react-router-dom";
import RestPassword from "./RestPassword";
import Sync from "./sync";
import { loginkey } from "./LoginContext";
import { useMediaQuery } from "react-responsive";
import React from "react";
import Register from "./register";
import { loginUserId } from "./LoginUserIdContext";
import { loginOrRegister } from "./LoginOrRegisterContext";


export default function DeleteAccount() {
    const [message, setMessage] = useState("");
    const [messageData, setMessageData] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [register, setRegister] = useState("0");
    const [infoo, setInfoo] = useState([]);
    const [infooLogin, setInfooLogin] = useState([]);
    const [forgot, setForgot] = useState(false);
    //const [loginOrRegister, setLoginOrRegister] = useState(false)
    const [confirm, setConfirm] = useState(0);
    const { setAuth } = useContext(loginkey);
    const { setId } = useContext(loginUserId);
    const { id } = useContext(loginUserId);
    const { setLogged } = useContext(loginOrRegister)
    const { logged } = useContext(loginOrRegister)
    const domainUrl = "drclinic.hassan-mohammad.tech"

    const getLoginFetchData = async (event) => {
        event.preventDefault();
        await fetch(`https://${domainUrl}/php/login.php?email=${email}&password=${password}`,
            {
                headers: {
                    "Content-Type": "text/html",
                    "charset": "utf-8"
                },
            }
        )
            .then((response) => {
                if (!response.ok) {
                    setMessage('loading...')
                    throw Error('Could not fetch the data')
                }
                else if (response.ok) {
                    setMessage('Done')
                    //sendEmail()
                    return response.json()
                }
            })
            .then(async (data) => {
                if (data.values.length === 0) {
                    setMessage("Wrong username or password")
                }
                if (data.values.length > 0) {
                    setMessage('Loading...');
                    data.values.map((e) => {
                        if (e.email == "test@test.test") {
                            setMessage("Please try another email")
                        } else {
                            handleDelete(e.id)
                        }
                    })
                    /*data.values.map((e) => {
                        setId(e.id)
                    })*/
                    //handlePushState();
                }
                return (
                    setInfoo(data.values));
            })
            .catch(err => {
                setMessage(err.message)
            })
    };
    function handleDelete(id) {
        const url = `https://${domainUrl}/php/deleteAccount.php`;
        const formData = new FormData();
        formData.append('email', email);
        formData.append('password', password);
        const config = {
            headers: {
                "Content-Type": "text/html",
                "charset": "utf-8"
            },
        };
        axios.post(url, formData, config).then(response => {
            if (response.status === 200) {
                handleDeletePatients(id)
            }
        })
            .catch(error => {
                console.log(error);
            });
    }




    function handleDeletePatients(doctorId) {
        const url = `https://${domainUrl}/php/DoctordeletePatient.php?loginuserid=${doctorId}`;
        const formData = new FormData();
        const config = {
            headers: {
                "Content-Type": "text/html",
                "charset": "utf-8"
            },
        };
        axios.post(url, formData, config).then(response => {
            if (response.status === 200) {
                handleDeleteSessions(doctorId);
            }
        })
            .catch(error => {
                console.log(error);
            });
    }
    function handleDeleteSessions(doctorId) {
        const url = `https://${domainUrl}/php/DoctordeletePatientSession.php?loginuserid=${doctorId}`;
        const formData = new FormData();
        const config = {
            headers: {
                "Content-Type": "text/html",
                "charset": "utf-8"
            },
        };
        axios.post(url, formData, config).then(response => {
            if (response.status === 200) {
                handleDeleteTreats(doctorId);
            }
        })
            .catch(error => {
                console.log(error);
            });
    }
    function handleDeleteTreats(doctorId) {
        const url = `https://${domainUrl}/php/DoctordeletePatientTreat.php?loginuserid=${doctorId}`;
        const formData = new FormData();
        const config = {
            headers: {
                "Content-Type": "text/html",
                "charset": "utf-8"
            },
        };
        axios.post(url, formData, config).then(response => {
            if (response.status === 200) {
                handleDeletePayments(doctorId);
            }
        })
            .catch(error => {
                console.log(error);
            });
    }
    function handleDeletePayments(doctorId) {
        const url = `https://${domainUrl}/php/DoctordeletePatientPayment.php?loginuserid=${doctorId}`;
        const formData = new FormData();
        const config = {
            headers: {
                "Content-Type": "text/html",
                "charset": "utf-8"
            },
        };
        axios.post(url, formData, config).then(response => {
            if (response.status === 200) {
                setMessage('Done')
                navToSync();
            }
        })
            .catch(error => {
                console.log(error);
            });
    }










    var sha1 = require('sha1');

    const handleEmailChange = (e) => {
        setEmail(e.target.value);
    }
    const handlePasswordChange = (e) => {
        setPassword(sha1(`${e.target.value}`));
    }
    const navigate = useNavigate();
    function navToRest() {
        if (email) {
            setForgot(true)
        } else {
            setMessage("Please add your email")
        }
        // navigate("/RestPassword", { replace: true });
    }

    function navToSync() {
        navigate("/", { replace: true });
    }
    const isDesktopOrLaptop = useMediaQuery({
        query: '(min-width: 1224px)'
    })
    const isBigScreen = useMediaQuery({ query: '(min-width: 1824px)' })
    const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' })
    const isPortrait = useMediaQuery({ query: '(orientation: portrait)' })
    const isRetina = useMediaQuery({ query: '(min-resolution: 2dppx)' })
    useEffect(() => {
        //getLoginAllData();
        //setPassword(sha1(`aa`));
    }, [])
    function handlePushState() {
        window.history.pushState({ id: 1 }, null, "GetPatients")
    }
    //console.log(window.location.href)
    return (
        <div>
            {isDesktopOrLaptop && <div className="login-page">
                <div className="container">
                    <div className="login-container" onSubmit={getLoginFetchData}>
                        <form className="login-form"><h4 className="title-login">Delete my account</h4>
                            <input type="email" className="form-control login-input" placeholder="Email" onChange={(event) => { handleEmailChange(event) }}></input>
                            <input type="password" className="form-control login-input" placeholder="Password" onChange={(event) => { handlePasswordChange(event) }}></input>
                            <div className="login-btn-container">
                                <button type="submit" className="btn btn-dark login-btn" disabled={email == "test@test.test"}>Delete</button>
                            </div>
                            {message && <div className="label-text">{message}</div>}
                        </form>
                    </div>
                </div>
            </div >}
            {
                isTabletOrMobile && <div className="login-page-mobile">
                    <div className="container-mobile">
                        <div className="login-container-mobile" onSubmit={getLoginFetchData}>
                            <form className="login-form-mobile"><h4 className="title-login">Delete my account</h4>
                                <input type="email" className="form-control login-input" placeholder="Email" onChange={(event) => { handleEmailChange(event) }}></input>
                                <input type="password" className="form-control login-input" placeholder="Password" onChange={(event) => { handlePasswordChange(event) }}></input>
                                <div className="login-btn-container-mobile">
                                    <button type="submit" className="btn btn-dark login-btn" disabled={email == "test@test.test"}>Delete</button>
                                </div>
                                {message && <div className="label-text">{message}</div>}
                            </form>
                        </div>
                    </div>
                </div>
            }
        </div >
    );
}
